'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFromPage = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = outfeatNavigation;

var _actionTypes = require('../actionTypes');

var _entities = require('./entities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = { fromPage: null };

function outfeatNavigation() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case _actionTypes.navigationActions.SET_FROM_PAGE:
      return (0, _extends3.default)({}, state, {
        fromPage: action.page
      });
    default:
      return state;
  }
}

var setFromPage = exports.setFromPage = function setFromPage(page) {
  return {
    type: _actionTypes.navigationActions.SET_FROM_PAGE, page: page
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/outfeatNavigation.js
 ** module id = 460
 ** module chunks = 0
 **/